var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoCuballama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "49.5px",
    height: "49.5px",
    viewBox: "0 0 59.5 59.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.765,
    y1: 0.821,
    x2: 29.765,
    y2: 58.4414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1487,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BDBDC6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M49.5,58.4H10.1c-5.3,0-9.6-4.3-9.6-9.6V10.4c0-5.3,4.3-9.6,9.6-9.6h39.4c5.3,0,9.6,4.3,9.6,9.6v38.4 C59.1,54.1,54.7,58.4,49.5,58.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E52529",
    d: "M48.4,32.9h4v7h-4V32.9z M7.1,32.9H11v7H7.1V32.9z M15.6,34.2c0-7.6,6.2-13.8,13.9-13.8 c7.7,0,13.9,6.2,13.9,13.8c0,7.6-6.2,13.8-13.9,13.8C21.9,48,15.6,41.8,15.6,34.2 M29.5,23.9c-5.7,0-10.3,4.6-10.3,10.3 c0,5.7,4.6,10.3,10.3,10.3c5.7,0,10.3-4.6,10.3-10.3C39.8,28.5,35.2,23.9,29.5,23.9 M34.4,34.9c0,2.7-2.2,4.8-4.9,4.8 c-2.7,0-4.9-2.2-4.9-4.8h-2.4c0,4,3.3,7.2,7.2,7.2c4,0,7.3-3.2,7.3-7.2H34.4z M27.3,31c0-1.3-1.1-2.4-2.4-2.4 c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4C26.2,33.4,27.3,32.3,27.3,31 M36.5,31c0-1.3-1.1-2.4-2.4-2.4 c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4C35.4,33.4,36.5,32.3,36.5,31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496F93",
    d: "M29.7,10.7c11.7,0,21.3,8.8,22.5,20.2h-4c-1.1-9.2-9-16.3-18.6-16.3c-9.6,0-17.4,7.1-18.6,16.3H7.2 C8.4,19.6,18,10.7,29.7,10.7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCuballama);
export default __webpack_public_path__ + "static/media/icono_cuballama.4c89a69c3b1dd5b5714563103266b7b8.svg";
export { ForwardRef as ReactComponent };